import { render, staticRenderFns } from "./AlarmsParameters.vue?vue&type=template&id=8aae355c&scoped=true"
import script from "./AlarmsParameters.vue?vue&type=script&lang=js"
export * from "./AlarmsParameters.vue?vue&type=script&lang=js"
import style0 from "./AlarmsParameters.vue?vue&type=style&index=0&id=8aae355c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aae355c",
  null
  
)

export default component.exports